export const MONITORING_CHANGE_DETAILS = {
  RUN_DATE: 'Run Date:',
  BACK: 'Back',
  NO_IMAGE: 'Could not load image. Please try again later.',
};
